module.exports = __webpack_public_path__ + "assets/Sigma.507cecf2da0dcc53fb82d45b1d1dcd32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Sigma.png
// module id = 798
// module chunks = 0